import clsx from 'clsx';
import { Icon } from 'components/Icon/Icon';
import { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';

type CompanyTransactionActionsProps = {
    onEdit: () => void;
    onDelete?: () => void;
    transaction: any;
    company: any;
};

export const CompanyTransactionActions: React.FC<CompanyTransactionActionsProps> = ({
    onEdit,
    onDelete,
    transaction,
    company,
}) => {
    const [isActive, setIsActive] = useState(false);
    const menu = useRef<any>(null);
    const { t } = useTranslation('documents');

    const handleClickOutside = (event: any) => {
        if (menu.current && !menu.current.contains(event.target)) {
            setIsActive(false);
        }
    };

    useEffect(() => {
        document.addEventListener('click', handleClickOutside, true);

        return () => {
            document.removeEventListener('click', handleClickOutside, true);
        };
    }, []);

    return (
        <div
            ref={menu}
            className={clsx('relative', {
                'z-10': isActive,
            })}
        >
            <Icon
                name="three-dots"
                className="h-4 hover:cursor-pointer"
                onClick={() => setIsActive(!isActive)}
            />
            {isActive && (
                <div className="absolute right-0 top-6 bg-white border border-zinc-200 rounded-md shadow-lg py-1 min-w-[160px]">
                    <button
                        className="w-full text-left px-4 py-2 text-sm hover:bg-zinc-50 flex items-center gap-2"
                        onClick={() => {
                            onEdit();
                            setIsActive(false);
                        }}
                    >
                        <Icon name="edit" className="h-4" />
                        {t('editAction')}
                    </button>
                    {onDelete && (
                        <button
                            className="w-full text-left px-4 py-2 text-sm hover:bg-zinc-50 flex items-center gap-2 text-red-600"
                            onClick={() => {
                                onDelete();
                                setIsActive(false);
                            }}
                        >
                            <Icon name="trash" className="h-4" />
                            {t('deleteAction')}
                        </button>
                    )}
                </div>
            )}
        </div>
    );
};
